import { render } from "./GlobalNotification.vue?vue&type=template&id=5065c5f8&scoped=true&lang=pug"
import script from "./GlobalNotification.vue?vue&type=script&lang=js"
export * from "./GlobalNotification.vue?vue&type=script&lang=js"

import "./GlobalNotification.vue?vue&type=style&index=0&id=5065c5f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5065c5f8"]])

export default __exports__